var _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegrationsActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 24.5,
    width: 184,
    height: 184,
    rx: 38.5,
    fill: "black",
    stroke: "black",
    strokeWidth: 45
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 304.5,
    width: 184,
    height: 184,
    rx: 38.5,
    fill: "black",
    stroke: "black",
    strokeWidth: 45
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 303.5,
    y: 24.5,
    width: 184,
    height: 184,
    rx: 38.5,
    fill: "black",
    stroke: "black",
    strokeWidth: 45
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 282,
    width: 47,
    height: 230,
    rx: 12,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 511,
    y: 374,
    width: 47,
    height: 230,
    rx: 12,
    transform: "rotate(90 511 374)",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationsActive);
export default __webpack_public_path__ + "static/media/integrations-active.67d0b6d8d74c242b991373e8a8993553.svg";
export { ForwardRef as ReactComponent };